import React, { useEffect, useRef, useState } from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import { classnames } from 'tailwindcss-classnames';

import Search from '../../assets/svg/search.svg';
import { useDebounce } from '../../hooks';

/**
 * https://www.algolia.com/doc/api-reference/widgets/search-box/react/
 * https://dev.to/gabe_ragland/debouncing-with-react-hooks-jci
 */

const LibrarySearchBox = connectSearchBox(({ refine }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const inputRef = useRef(null);
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    if (debouncedSearchTerm) {
      refine(searchTerm);
    } else {
      refine('');
    }
  }, [debouncedSearchTerm]);

  return (
    <div
      className={classnames(
        'flex',
        'w-full',
        'border',
        'border-smoke',
        'pl-6',
        'cursor-text',
      )}
      onBlur={() => {
        setFocused(false);
      }}
      onFocus={() => {
        setFocused(true);
        inputRef?.current?.focus();
      }}
      role="presentation"
      tabIndex="-1"
    >
      {focused && (
        <Search
          className={classnames(
            'fill-current',
            'text-slate',
            'w-5',
            'max-h-14',
            'mr-3',
          )}
        />
      )}

      <form
        action=""
        className="flex-1 overflow-hidden py-4"
        data-component-id="library_search_box"
        noValidate
        onSubmit={(e) => e.preventDefault()}
        role="search"
      >
        <input
          ref={inputRef}
          aria-label="Search"
          className={classnames(
            'appearance-none',
            'bg-transparent',
            'border-0',
            'outline-none',
            'stink-body-3',
            'text-smoke',
            'w-full',
          )}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search"
          type="search"
        />
      </form>
      {!focused && (
        <>
          <div className="border-l border-smoke" />
          <Search className="w-5 mx-3 max-h-14 fill-current text-slate" />
        </>
      )}
    </div>
  );
});

export default LibrarySearchBox;
